import {
  CompanyOperationalStatus,
  DeliveryMode,
  InvoiceStatus,
  SetupPackageType,
  SubscriptionTerm,
} from '../../../../../services/exports/Constants';

export default {
  sections: {
    people: 'Personas',
    financial_metrics: 'Métricas financieras',
    onboarding_and_quality: 'Onboarding y calidad',
    subscriptions: 'Suscripciones actuales',
    payments: 'Pagos',
    last_invoices: 'Últimas facturas',
  },
  fields: {
    google_profile: 'Perfil de Google',
    owner_name: 'Nombre del propietario',
    owner_phone_number: 'Teléfono del propietario',
    company_phone_number: 'Teléfono del restaurante',
    address: 'Dirección',
    onboarding_manager: 'Responsable de onboarding',
    sales_manager: 'Responsable de ventas',
    last_30_days_sales: 'Ingresos últimos 30 días',
    lifetime_sales: 'Ingresos totales',
    monthly_sales_other_platforms: 'Ventas en apps de delivery',
    delivery_app_sales_at_go_live: 'Ventas en apps de delivery en la fecha de lanzamiento',
    last_payout: 'Último pago',
    potential_tier: 'Puntuación potencial',
    current_tier: 'Puntuación IST',
    signed_at: 'Fecha de cierre',
    live_from: 'Fecha de lanzamiento',
    onboarding_quality_score: 'Puntuación de calidad al lanzar',
    is_google_business_available: 'Google Business disponible',
    is_smart_pricing_configured: 'Precios más bajos que Lieferando, Wolt, Uber',
    is_flyers_package_sent: 'Flyer promocional enviado',
    is_menu_fully_configured: 'Todos los artículos del menú disponibles',
    has_offers_on_competitor_platforms:
      '¿El restaurante tiene ofertas en Wolt, Uber, Lieferando (salvo entrega gratuita)?',
    is_instagram_story_shared: 'Historia de Instagram compartida con el propietario',
    is_order_system_connected_to_website: 'Web de Foodamigos conectada O botón de pedido online añadido en web propia',
    delivery_mode: 'Repartidores',
    has_storefront: 'Web de {{provider}}',
    screening_date: 'Fecha de revisión',
  },
  setup_fee: {
    title: 'Tarifa de implementación',
    status: {
      [InvoiceStatus.Paid]: 'Pagado',
      [InvoiceStatus.Pending]: 'Pendiente',
      [InvoiceStatus.Processing]: 'Procesando',
      [InvoiceStatus.Refunded]: 'Reembolsado',
      [InvoiceStatus.PartiallyRefunded]: 'Reembolsado parcialmente',
      [InvoiceStatus.Failed]: 'Fallido',
    },
  },
  labels: {
    yes: 'Sí',
    no: 'No',
    month: 'Mes',
    recorded_on: 'Registrado el {{date}}',
  },
  delivery_app_sales_correction: {
    title: 'Corregir ventas en apps de delivery en el lanzamiento',
    description:
      'Corrige aquí solo una errata. Es la cifra mensual que onboarding registró cuando el restaurante se lanzó, y el reporting la compara con la de ventas. El cambio queda registrado.',
  },
  operational_status: {
    [CompanyOperationalStatus.Live]: 'Activo',
    [CompanyOperationalStatus.Paused]: 'Pausado',
    [CompanyOperationalStatus.Suspended]: 'Cancelado',
  },
  setup_packages: {
    [SetupPackageType.Default]: 'Estándar',
    [SetupPackageType.Preferred]: 'Pro',
    [SetupPackageType.Custom]: 'Plus',
  },
  contract_terms: {
    [SubscriptionTerm.Monthly]: 'Mensual',
    [SubscriptionTerm.Annual]: 'Anual',
  },
  delivery_modes: {
    [DeliveryMode.Internal]: 'Conductores propios',
    [DeliveryMode.External]: 'Conductores de {{provider}}',
  },
  buttons: {
    view_details: 'Ver detalles',
    open: 'Abrir',
    correct: 'Corregir',
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar datos',
    delivery_app_sales_corrected: 'Ventas en apps de delivery corregidas',
    failed_to_correct_delivery_app_sales: 'No se pudieron corregir las ventas en apps de delivery',
  },
};
